module.exports = __webpack_public_path__ + "static/media/dragon-fortune.f8068fd7.webp";